module.exports = __webpack_public_path__ + "img/ezhr.5847b4af.jpg";